import cx from 'classnames';
import { Location } from 'history';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import AboutMe, { AboutMePlaceholder } from 'mk2/apps/blogs/components/AboutMe';
import MoreAboutMe, { AvatarGridType } from 'mk2/apps/blogs/components/MoreAboutMe';
import { checkIfmoreAboutMeHasContent } from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.helpers';
import { ProfileDetailData } from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.reducers';
import { Panel } from 'mk2/components/Panel';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ProfileSideMenu.mscss';

interface OwnProps {
    className?: string;
    isMobile: boolean;
    loadingState: LoadingState;
    location: Location;
    profileDetailData: ProfileDetailData;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    username: string;
    onDeleteAvatarByAdmin(username: string);
    onExpandAvatarGrid(avatarGridType: AvatarGridType, username: string);
    onExpandGroupList(username: string);
    onLoadProfileDetail(username: string);
    onSetLikeUser(username: string, like: boolean);
}

type Props = OwnProps;

export class ProfileSideMenu extends React.PureComponent<Props> {

    public render() {
        const { isMobile, profileDetailData, loadingState } = this.props;

        return isMobile ? null : (
            <LoadingSwitch
                loadingState={loadingState}
                onLoad={this.loadDetail}
                onRenderInit={this.renderInit}
                onRenderSuccess={this.renderLoadSuccess}
                onRenderFailure={this.renderFailure}
                hasData={!!profileDetailData.user}
            />
        );

    }

    private loadDetail = () => {
        const { onLoadProfileDetail, username } = this.props;
        onLoadProfileDetail(username);
    };

    private renderLoadSuccess = () => {
        const {
            className,
            isMobile,
            location,
            onDeleteAvatarByAdmin,
            onExpandAvatarGrid,
            onExpandGroupList,
            onSetLikeUser,
            profileDetailData,
            requestUser,
            requestUserPermissions,
        } = this.props;

        const moreAboutMeHasContent = checkIfmoreAboutMeHasContent(
            isMobile,
            profileDetailData,
            requestUser,
            requestUserPermissions,
        );

        return (
            <Panel className={cx(styles.ProfileSideMenu, className)}>
                <AboutMe
                    isMobile={isMobile}
                    location={location}
                    onDeleteAvatarByAdmin={onDeleteAvatarByAdmin}
                    onSetLikeUser={onSetLikeUser}
                    profileDetailData={profileDetailData}
                    requestUser={requestUser}
                    requestUserPermissions={requestUserPermissions}
                    moreAboutMeHasContent={moreAboutMeHasContent}
                />
                {isAuthenticated(requestUser) && moreAboutMeHasContent && (
                    <MoreAboutMe
                        isMobile={isMobile}
                        location={location}
                        onExpandAvatarGrid={onExpandAvatarGrid}
                        onExpandGroupList={onExpandGroupList}
                        profileDetailData={profileDetailData}
                        requestUser={requestUser}
                        requestUserPermissions={requestUserPermissions}
                    />
                )}
            </Panel>
        );
    };

    private renderInit = () => {
        const { className, isMobile, username } = this.props;

        return (
            <Panel className={cx(styles.ProfileSideMenu, className)}>
                <AboutMePlaceholder isMobile={isMobile} username={username} />
            </Panel>
        );
    };

    private renderFailure = () => {
        return null;
    };
}


export default ProfileSideMenu;
